// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const de_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const es_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha`
};

const fr_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const fi_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Päivämäärä`
};

const hi_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `तारीख`
};

const ja_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `日付`
};

const nl_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const pt_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const ro_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const th_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `วันที่`
};

const ur_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `تاریخ`
};

const zh_hant1_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `日期`
};

const da_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Dato`
};

const it_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const vn_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Ngày`
};

const ko_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `날짜`
};

const tr_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Tarih`
};

const lv_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datums`
};

const ar_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `التاريخ`
};

const bs_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const sl_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const id_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Tanggal`
};

const sv_widget_referrals_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_referrals_date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_referrals_date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_referrals_date", locale)
	if (locale === "en") return en_widget_referrals_date(inputs)
	if (locale === "de") return de_widget_referrals_date(inputs)
	if (locale === "es") return es_widget_referrals_date(inputs)
	if (locale === "fr") return fr_widget_referrals_date(inputs)
	if (locale === "fi") return fi_widget_referrals_date(inputs)
	if (locale === "hi") return hi_widget_referrals_date(inputs)
	if (locale === "ja") return ja_widget_referrals_date(inputs)
	if (locale === "nl") return nl_widget_referrals_date(inputs)
	if (locale === "pt") return pt_widget_referrals_date(inputs)
	if (locale === "ro") return ro_widget_referrals_date(inputs)
	if (locale === "th") return th_widget_referrals_date(inputs)
	if (locale === "ur") return ur_widget_referrals_date(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_referrals_date(inputs)
	if (locale === "da") return da_widget_referrals_date(inputs)
	if (locale === "it") return it_widget_referrals_date(inputs)
	if (locale === "vn") return vn_widget_referrals_date(inputs)
	if (locale === "ko") return ko_widget_referrals_date(inputs)
	if (locale === "tr") return tr_widget_referrals_date(inputs)
	if (locale === "lv") return lv_widget_referrals_date(inputs)
	if (locale === "ar") return ar_widget_referrals_date(inputs)
	if (locale === "bs") return bs_widget_referrals_date(inputs)
	if (locale === "sl") return sl_widget_referrals_date(inputs)
	if (locale === "id") return id_widget_referrals_date(inputs)
	if (locale === "sv") return sv_widget_referrals_date(inputs)
	return "widget_referrals_date"
};